import { Component, ViewChild, Input, EventEmitter, Output, OnInit, OnChanges } from "@angular/core";
import { ModalComponent } from "../modal.component";
import * as moment from 'moment';
import { ToasterService } from 'angular5-toaster';
import { User } from "../../core/user";
import { ReviewService } from "../../providers/review.service";
import { AbstractEnhancedReview, UserComment } from "../../core/review";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { StorageService } from "../../storage.service";
import { TramApiService } from "../../tram-api.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
    selector: 'change-name-form',
    templateUrl: './change-name-form.component.html',
    styleUrls: ['./change-name-form.component.scss']
})
export class ChangeNameFormComponent {
    user: User;
    name: string;
    @Output() closed = new EventEmitter();
    @ViewChild('modal') modal: ModalComponent;

    isLoading: boolean;

    constructor(
        private api: TramApiService,
        private storage: StorageService,
        private toaster: ToasterService) {
        storage.isSensitiveDataExist.subscribe(v => {
            if (v) {
                api.getCurrentUser().then(u => {
                    this.user = u;
                    this.name = u.name;
                });
            } else {
                this.user = null;
                this.name = null;
            }
        });
    }

    open(force) {
        if (!this.user)
            return;

        if (!force && this.user && this.name) {
            this.closed.emit(this.name);
            return;
        }

        this.modal.open();
    }

    changeName() {
        this.isLoading = true;
        this.api.setName(this.user, this.name)
            .then(response => {
                this.isLoading = false;

                this.toaster.pop('success', null, 'Имя успешно изменено');

                this.closed.emit(this.name);
                this.modal.close();
            }).catch(error => {
                this.handleError(error);
            });
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/account/change-name-form.component.ts